import { gql } from "@apollo/client";

export const userBadgesMutation = gql`
  mutation userBadgesMutation($input: UserBadgesInput!) {
    userBadgesMutation(input: $input) {
      id
      badge
      userId
      companyId
      comment
    }
  }
`;

export const userBadgesSubscription = gql`
  subscription userBadgesSubscription($userId: String) {
    onUserBadgesMutation(userId: $userId) {
      id
      badge
      userId
      companyId
      comment
    }
  }
`;
